export default __webpack_public_path__ + "static/media/timing_3.6e653c50.jpg";